<!-- eslint-disable vuejs-accessibility/click-events-have-key-events -->
/* eslint-disable */
<template>
  <div class="view--work-center-calendar">
    <v-card outlined flat class="mb-4">
      <v-card-title class="d-flex align-center flex-wrap">
        <v-icon left color="primary">mdi-calendar-month</v-icon>
        Calendario de fines de semana y festivos

        <v-spacer></v-spacer>

        <v-select v-model="selectedYear" :items="years" label="Año" outlined dense hide-details
          class="year-selector mr-4" @change="fetchItems"></v-select>

        <v-btn v-if="isSuperAdmin" color="secondary" @click="dialogBulk = true" depressed outlined class="mr-2">
          <v-icon left>mdi-calendar-weekend</v-icon>
          Cargar Fines de Semana
        </v-btn>

        <v-btn v-if="isSuperAdmin" color="primary" @click="openCreateDialog" depressed>
          <v-icon left>mdi-plus</v-icon>
          Nuevo Registro
        </v-btn>
      </v-card-title>

      <v-divider></v-divider>

      <div class="calendar-container mt-4" v-if="!loading">
        <div class="calendar-grid-wrapper">
          <div class="calendar-compact-grid">
            <div v-for="(monthName, mIndex) in monthNames" :key="mIndex" class="month-column">
              <div class="month-header">{{ monthName }}</div>
              <div class="month-body">
                <div v-for="entry in getMonthEntries(mIndex)" :key="entry.id"
                  :class="[getEntryClass(entry), { 'readonly-cell': !isSuperAdmin }]" @click="openEditDialog(entry)">
                  <div class="entry-content">
                    <span class="day-num">{{ getDayNum(entry.date) }}</span>
                    <span class="day-weekday">{{ getWeekdayForDate(entry.date) }}</span>
                    <span class="day-type">{{ typeAbbrMap[entry.type] || entry.type.substring(0, 2) }}</span>
                  </div>
                </div>
                <div v-if="getMonthEntries(mIndex).length === 0" class="empty-month-placeholder">
                  <!-- No hay registros -->
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Legend and National Holidays Section -->
        <v-row class="mt-6 px-2">
          <v-col cols="12" md="4">
            <v-card outlined class="legend-card pa-3 h-100">
              <div class="legend-title mb-3">LEYENDA</div>
              <div class="legend-grid">
                <div v-for="(abbr, type) in typeAbbrMap" :key="type" class="legend-item mb-1">
                  <span class="legend-abbr" :class="'type-' + typeColorMap[type]">{{ abbr }}</span>
                  <span class="legend-text">{{ type }}</span>
                </div>
                <div class="legend-item">
                  <span class="legend-abbr type-grey">FS</span>
                  <span class="legend-text">FIN DE SEMANA</span>
                </div>
              </div>
            </v-card>
          </v-col>

          <v-col cols="12" md="8">
            <v-card outlined class="pa-3 h-100" color="#fafafa">
              <div class="legend-title mb-3">FIESTAS NACIONALES ({{ selectedYear }})</div>

              <div v-if="nationalHolidays.length > 0">
                <v-row no-gutters>
                  <v-col cols="12" sm="6" v-for="holiday in nationalHolidays" :key="holiday.id">
                    <div class="dynamic-holiday-item pa-2">
                      <v-icon small left color="red darken-1">mdi-flag</v-icon>
                      <span class="holiday-date font-weight-medium">{{ formatHolidayDate(holiday.date) }}</span>
                      <span v-if="holiday.description" class="holiday-desc ml-2 grey--text text--darken-1">
                        - {{ holiday.description }}
                      </span>
                    </div>
                  </v-col>
                </v-row>
              </div>
              <div v-else class="pa-4 text-center grey--text text--darken-1 italic">
                No hay fiestas nacionales cargadas.
              </div>
            </v-card>
          </v-col>
        </v-row>

        <!-- Regional and Local Holidays -->
        <v-row class="mt-4 px-2">
          <v-col cols="12" md="6">
            <v-card outlined class="pa-3 h-100" color="#fafafa">
              <div class="legend-title mb-3">FIESTAS AUTONÓMICAS</div>
              <div v-if="regionalHolidays.length > 0">
                <v-row no-gutters>
                  <v-col cols="12" v-for="holiday in regionalHolidays" :key="holiday.id">
                    <div class="dynamic-holiday-item pa-2">
                      <v-icon small left color="yellow darken-2">mdi-map-marker-radius</v-icon>
                      <span class="holiday-date font-weight-medium">{{ formatHolidayDate(holiday.date) }}</span>
                      <span v-if="holiday.description" class="holiday-desc ml-2 grey--text text--darken-1">
                        - {{ holiday.description }}
                      </span>
                    </div>
                  </v-col>
                </v-row>
              </div>
              <div v-else class="pa-4 text-center grey--text text--darken-1 italic">
                No hay fiestas autonómicas cargadas.
              </div>
            </v-card>
          </v-col>

          <v-col cols="12" md="6">
            <v-card outlined class="pa-3 h-100" color="#fafafa">
              <div class="legend-title mb-3">FIESTAS LOCALES</div>
              <div v-if="localHolidays.length > 0">
                <v-row no-gutters>
                  <v-col cols="12" v-for="holiday in localHolidays" :key="holiday.id">
                    <div class="dynamic-holiday-item pa-2">
                      <v-icon small left color="green darken-1">mdi-city</v-icon>
                      <span class="holiday-date font-weight-medium">{{ formatHolidayDate(holiday.date) }}</span>
                      <span v-if="holiday.description" class="holiday-desc ml-2 grey--text text--darken-1">
                        - {{ holiday.description }}
                      </span>
                    </div>
                  </v-col>
                </v-row>
              </div>
              <div v-else class="pa-4 text-center grey--text text--darken-1 italic">
                No hay fiestas locales cargadas.
              </div>
            </v-card>
          </v-col>
        </v-row>

        <!-- Agreement Adjustments -->
        <v-row class="mt-4 px-2 pb-4">
          <v-col cols="12">
            <v-card outlined class="pa-3" color="#fafafa">
              <div class="legend-title mb-3">AJUSTES HORARIOS CONVENIO</div>
              <div v-if="adjustmentHolidays.length > 0">
                <v-row no-gutters>
                  <v-col cols="12" sm="4" v-for="holiday in adjustmentHolidays" :key="holiday.id">
                    <div class="dynamic-holiday-item pa-2">
                      <v-icon small left color="light-blue darken-1">mdi-clock-edit</v-icon>
                      <span class="holiday-date font-weight-medium">{{ formatHolidayDate(holiday.date) }}</span>
                      <span v-if="holiday.description" class="holiday-desc ml-2 grey--text text--darken-1">
                        - {{ holiday.description }}
                      </span>
                    </div>
                  </v-col>
                </v-row>
              </div>
              <div v-else class="pa-4 text-center grey--text text--darken-1 italic">
                No hay ajustes horarios de convenio cargados.
              </div>
            </v-card>
          </v-col>
        </v-row>
      </div>

      <div v-else class="d-flex justify-center pa-10">
        <v-progress-circular indeterminate color="primary"></v-progress-circular>
      </div>
    </v-card>

    <!-- Create/Edit Modal -->
    <v-dialog v-model="dialog" width="650px" persistent>
      <v-container fluid class="pa-0">
        <v-card outlined class="p-3" :elevation="$getCardOptions('elevation')">
          <v-card-title>
            <section-header :first="editedIndex === -1 ? 'Completa los campos' : 'Modifica los campos'"
              :second="editedIndex === -1 ? 'y añade el nuevo registro' : 'del registro del calendario'" />
          </v-card-title>

          <v-card-text>
            <v-form ref="form">
              <v-row>
                <v-col cols="12" md="6">
                  <label class="input-field--label"> Selecciona la fecha: </label>
                  <v-date-picker v-model="editedItem.date" locale="es" first-day-of-week="1" full-width no-title
                    class="mt-2 border rounded" :color="$getColor('vuetifyColor1')"></v-date-picker>
                </v-col>

                <v-col cols="12" md="6">
                  <div class="mb-6">
                    <label class="input-field--label"> Fecha seleccionada: </label>
                    <v-text-field v-model="editedItem.date" placeholder="Selecciona en el calendario"
                      prepend-inner-icon="mdi-calendar" readonly outlined dense :color="$getColor('vuetifyColor1')"
                      hide-details></v-text-field>
                  </div>

                  <div class="mb-6">
                    <label class="input-field--label"> Tipo de festivo: </label>
                    <v-select v-model="editedItem.type" :items="typeOptions" placeholder="Seleccionar tipo" outlined
                      dense prepend-inner-icon="mdi-label" :color="$getColor('vuetifyColor1')"></v-select>
                  </div>

                  <div class="mb-6">
                    <label class="input-field--label"> Descripción: </label>
                    <v-textarea v-model="editedItem.description" placeholder="Ej: Festivo local por patrona" outlined
                      dense rows="3" :color="$getColor('vuetifyColor1')" hide-details></v-textarea>
                  </div>

                  <div>
                    <label class="input-field--label"> Disponibilidad: </label>
                    <v-switch v-model="editedItem.available"
                      :label="editedItem.available ? 'Disponible (Laborable)' : 'No Disponible (Festivo)'"
                      color="success" inset class="mt-0"></v-switch>
                  </div>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn v-if="editedIndex > -1" color="error" text @click="confirmDelete(editedItem)">
              Eliminar
            </v-btn>
            <v-btn color="grey darken-1" text @click="close">
              Cancelar
            </v-btn>
            <v-btn class="white--text" :rounded="$getPrimaryButton('rounded')" :outlined="$getPrimaryButton('outlined')"
              :color="$getPrimaryButton('color')" large @click="save" :loading="saving">
              {{ editedIndex === -1 ? 'Añadir Registro' : 'Guardar Cambios' }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-container>
    </v-dialog>

    <!-- Bulk Load Modal -->
    <v-dialog v-model="dialogBulk" max-width="480px">
      <v-card outlined class="pa-4">
        <v-card-title class="pa-0 mb-3">
          <section-header first="Cargar fines de semana" :second="'para el año ' + selectedYear" />
        </v-card-title>
        <v-card-text class="pa-0 py-2 text-body-1">
          <p class="mb-2">
            Esta acción generará automáticamente los registros para todos los sábados y domingos del año <strong>{{ selectedYear }}</strong> para este centro de trabajo.
          </p>

          <div v-if="hasWeekendsLoaded" class="pa-3 rounded amber lighten-5 orange--text text--darken-4 mt-3 mb-0 font-weight-medium text-body-2">
            * Los fines de semana para el año {{ selectedYear }} ya se encuentran cargados en el calendario.
          </div>
          <p v-else class="mb-0 mt-3 font-weight-medium">
            ¿Deseas continuar?
          </p>
        </v-card-text>
        <v-card-actions class="pa-0 pt-4">
          <v-spacer></v-spacer>
          <v-btn color="grey darken-1" text @click="dialogBulk = false">
            Cancelar
          </v-btn>
          <v-btn class="white--text" :rounded="$getPrimaryButton('rounded')" :outlined="$getPrimaryButton('outlined')"
            :color="$getPrimaryButton('color')" @click="handleBulkLoad" :loading="loadingBulk" :disabled="hasWeekendsLoaded">
            Confirmar Carga
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Delete Confirmation -->
    <v-dialog v-model="dialogDelete" max-width="400px">
      <v-card outlined class="p-3">
        <v-card-title class="text-h5">Confirmar eliminación</v-card-title>
        <v-card-text class="pt-4">¿Estás seguro de que deseas eliminar este registro del calendario?</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey darken-1" text @click="closeDelete">Cancelar</v-btn>
          <v-btn color="error" @click="deleteItemConfirm" :loading="deleting" depressed>Eliminar</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Snackbar for notifications -->
    <v-snackbar v-model="snackbar.show" :color="snackbar.color" timeout="3000">
      {{ snackbar.text }}
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="snackbar.show = false">Cerrar</v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import moment from 'moment';
import WorkCenterCalendarService from '@/services/workcenter-calendar.service';
import loggedUserService from '@/services/logged-user.service';
import SectionHeader from '@/components/Headers/SectionHeader.vue';

export default {
  name: 'WorkCenterCalendar',
  components: {
    SectionHeader,
  },
  data: () => ({
    loading: false,
    saving: false,
    deleting: false,
    loadingBulk: false,
    items: [],
    selectedYear: new Date().getFullYear(),
    years: [],
    monthNames: [
      'ENERO', 'FEBRERO', 'MARZO', 'ABRIL', 'MAYO', 'JUNIO',
      'JULIO', 'AGOSTO', 'SEPTIEMBRE', 'OCTUBRE', 'NOVIEMBRE', 'DICIEMBRE',
    ],
    typeOptions: [
      'FIESTA NACIONAL',
      'FIESTA AUTONOMICA',
      'FIESTA LOCAL',
      'FIESTA CONVENIO',
      'AJUSTE HOR. CONVENIO',
      'NO LABORABLE NO RECUP.',
    ],
    typeAbbrMap: {
      'FIESTA NACIONAL': 'FN',
      'FIESTA AUTONOMICA': 'FA',
      'FIESTA LOCAL': 'FL',
      'FIESTA CONVENIO': 'FC',
      'AJUSTE HOR. CONVENIO': 'AHC',
      'NO LABORABLE NO RECUP.': 'NL',
    },
    typeColorMap: {
      'FIESTA NACIONAL': 'red',
      'FIESTA AUTONOMICA': 'yellow',
      'FIESTA LOCAL': 'green',
      'FIESTA CONVENIO': 'orange',
      'AJUSTE HOR. CONVENIO': 'lightblue',
      'NO LABORABLE NO RECUP.': 'purple',
    },
    dialog: false,
    dialogDelete: false,
    dialogBulk: false,
    editedIndex: -1,
    editedItem: {
      id: null,
      date: null,
      type: '',
      description: '',
      available: false,
      workCenterId: null,
    },
    defaultItem: {
      id: null,
      date: null,
      type: '',
      description: '',
      available: false,
      workCenterId: null,
    },
    snackbar: {
      show: false,
      text: '',
      color: 'success',
    },
  }),

  computed: {
    isSuperAdmin() {
      return this.$store.getters['auth/hasRole'](['ROLE_SUPER_ADMIN']);
    },
    workCenterId() {
      return this.$store.state.projectId;
    },
    hasWeekendsLoaded() {
      return this.items.some((item) => {
        const date = moment.utc(item.date);
        return date.year() === Number(this.selectedYear) && item.type === 'FS';
      });
    },
    itemsByMonth() {
      const months = Array.from({ length: 12 }, () => []);
      this.items.forEach((item) => {
        const date = moment.utc(item.date);
        if (date.year() === this.selectedYear) {
          months[date.month()].push(item);
        }
      });
      // Sort each month by date
      months.forEach((month) => {
        month.sort((a, b) => moment.utc(a.date).diff(moment.utc(b.date)));
      });
      return months;
    },
    nationalHolidays() {
      return this.items
        .filter((item) => item.type === 'FIESTA NACIONAL' && moment.utc(item.date).year() === this.selectedYear)
        .sort((a, b) => moment.utc(a.date).diff(moment.utc(b.date)));
    },
    regionalHolidays() {
      return this.items
        .filter((item) => item.type === 'FIESTA AUTONOMICA' && moment.utc(item.date).year() === this.selectedYear)
        .sort((a, b) => moment.utc(a.date).diff(moment.utc(b.date)));
    },
    localHolidays() {
      return this.items
        .filter((item) => item.type === 'FIESTA LOCAL' && moment.utc(item.date).year() === this.selectedYear)
        .sort((a, b) => moment.utc(a.date).diff(moment.utc(b.date)));
    },
    adjustmentHolidays() {
      return this.items
        .filter((item) => item.type === 'AJUSTE HOR. CONVENIO' && moment.utc(item.date).year() === this.selectedYear)
        .sort((a, b) => moment.utc(a.date).diff(moment.utc(b.date)));
    },
  },

  watch: {
    dialog(val) {
      if (!val) this.close();
    },
    dialogDelete(val) {
      if (!val) this.closeDelete();
    },
    workCenterId(newVal) {
      if (newVal) {
        this.fetchItems();
      }
    },
  },

  mounted() {
    this.generateYears();
    if (!this.workCenterId) {
      if (this.$store.getters['auth/hasRole'](['ROLE_SUPER_ADMIN', 'ROLE_ADMIN', 'ROLE_ENCARGADO'])) {
        if (this.$route.name !== 'SelectWorkCenter') {
          this.$router.push({ name: 'SelectWorkCenter' }).catch(() => {});
        }
      } else if (this.$store.getters['auth/hasRole'](['ROLE_TRABAJADOR'])) {
        this.loading = true;
        loggedUserService.getWorkCenter()
          .then((response) => {
            this.$store.commit('setProject', {
              value: response.id,
              text: response.name,
              availableSchedule: response.availableSchedule,
              availableClockEntries: response.availableClockEntries,
              availableN3: response.availableN3,
            });
            this.fetchItems();
          })
          .catch((error) => {
            console.error('Error fetching worker work center:', error);
            this.loading = false;
          });
      }
    } else {
      this.fetchItems();
    }
  },

  methods: {
    generateYears() {
      const currentYear = new Date().getFullYear();
      for (let i = currentYear - 2; i <= currentYear + 5; i += 1) {
        this.years.push(i);
      }
    },

    getMonthEntries(monthIndex) {
      return this.itemsByMonth[monthIndex] || [];
    },

    getDayNum(date) {
      return moment.utc(date).date();
    },

    getWeekdayForDate(date) {
      const m = moment.utc(date).locale('es');
      return m.format('dd').toUpperCase().charAt(0);
    },

    formatHolidayDate(date) {
      return moment.utc(date).locale('es').format('D [de] MMMM');
    },

    getEntryClass(entry) {
      const classes = ['entry-cell'];
      const colorClass = this.typeColorMap[entry.type];
      if (colorClass) {
        classes.push(`type-${colorClass}`);
      }
      return classes.join(' ');
    },

    fetchItems() {
      if (!this.workCenterId) return;

      this.loading = true;
      const params = {
        page: 0,
        size: 1000,
        sort: 'date',
        direction: 'asc',
      };

      WorkCenterCalendarService.getCalendarEntriesByWorkCenter(this.workCenterId, params)
        .then((response) => {
          this.items = response.data.content;
          this.loading = false;
        })
        .catch((error) => {
          console.error('Error fetching calendar entries:', error);
          this.showSnackbar('Error al cargar los datos', 'error');
          this.loading = false;
        });
    },

    handleBulkLoad() {
      this.loadingBulk = true;
      WorkCenterCalendarService.bulkLoadWeekends(this.workCenterId, this.selectedYear)
        .then((response) => {
          this.showSnackbar(`Se han creado ${response.data} registros de fin de semana.`);
          this.fetchItems();
          this.dialogBulk = false;
        })
        .catch((error) => {
          console.error('Error bulk loading weekends:', error);
          this.showSnackbar('Error al cargar los fines de semana', 'error');
        })
        .finally(() => {
          this.loadingBulk = false;
        });
    },

    openCreateDialog() {
      this.editedIndex = -1;
      this.editedItem = JSON.parse(JSON.stringify(this.defaultItem));
      this.editedItem.workCenterId = this.workCenterId;
      this.dialog = true;
    },

    openEditDialog(item) {
      if (!this.isSuperAdmin) return;
      this.editedIndex = this.items.indexOf(item);
      this.editedItem = JSON.parse(JSON.stringify(item));
      this.editedItem.date = moment.utc(item.date).format('YYYY-MM-DD');
      this.editedItem.workCenterId = item.workCenter ? item.workCenter.id : this.workCenterId;
      this.dialog = true;
    },

    confirmDelete(item) {
      this.editedIndex = this.items.indexOf(item);
      this.editedItem = JSON.parse(JSON.stringify(item));
      this.dialogDelete = true;
      this.dialog = false;
    },

    deleteItemConfirm() {
      this.deleting = true;
      WorkCenterCalendarService.deleteCalendarEntry(this.editedItem.id)
        .then(() => {
          this.showSnackbar('Registro eliminado correctamente');
          this.fetchItems();
          this.closeDelete();
        })
        .catch((error) => {
          console.error('Error deleting calendar entry:', error);
          this.showSnackbar('Error al eliminar el registro', 'error');
        })
        .finally(() => {
          this.deleting = false;
        });
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = JSON.parse(JSON.stringify(this.defaultItem));
        this.editedIndex = -1;
      });
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = JSON.parse(JSON.stringify(this.defaultItem));
        this.editedIndex = -1;
      });
    },

    save() {
      if (!this.editedItem.date) {
        this.showSnackbar('Por favor, selecciona una fecha', 'error');
        return;
      }
      this.saving = true;
      const formattedDate = moment.utc(this.editedItem.date).toISOString();

      const data = {
        ...this.editedItem,
        date: formattedDate,
      };

      const request = this.editedIndex > -1
        ? WorkCenterCalendarService.updateCalendarEntry(this.editedItem.id, data)
        : WorkCenterCalendarService.createCalendarEntry(data);

      request
        .then(() => {
          this.showSnackbar(this.editedIndex > -1 ? 'Registro actualizado' : 'Registro creado');
          this.fetchItems();
          this.close();
        })
        .catch((error) => {
          console.error('Error saving calendar entry:', error);
          this.showSnackbar('Error al guardar el registro', 'error');
        })
        .finally(() => {
          this.saving = false;
        });
    },

    showSnackbar(text, color = 'success') {
      this.snackbar.text = text;
      this.snackbar.color = color;
      this.snackbar.show = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.view--work-center-calendar {
  padding: 20px;
}

.year-selector {
  max-width: 150px;
}

.calendar-container {
  background: white;
  padding: 10px;
  border-radius: 4px;
}

.calendar-grid-wrapper {
  overflow-x: auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
  width: 100%;
}

.calendar-compact-grid {
  display: flex;
  gap: 8px;
  min-width: 950px;
  padding-bottom: 5px;
}

.month-column {
  flex: 1;
  min-width: 80px;
  border: 1px solid #eee;
  display: flex;
  flex-direction: column;
  background: #fdfdfd;
}

.month-header {
  background-color: #f5f5f5;
  font-weight: bold;
  padding: 8px 4px;
  text-align: center;
  font-size: 11px;
  border-bottom: 2px solid #ddd;
}

.month-body {
  flex-grow: 1;
  min-height: 100px;
}

.entry-cell {
  cursor: pointer;
  padding: 4px;
  border-bottom: 1px solid #eee;
  transition: transform 0.1s;
  font-size: 11px;

  &:hover {
    transform: scale(1.02);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }

  // Color maps
  &.type-red {
    background-color: #ffcdd2;
    color: #b71c1c;
    font-weight: bold;
    border-color: #ef9a9a;
  }

  &.type-yellow {
    background-color: #fff9c4;
    border-color: #fff176;
  }

  &.type-green {
    background-color: #c8e6c9;
    border-color: #81c784;
  }

  &.type-orange {
    background-color: #ffe0b2;
    border-color: #ffb74d;
  }

  &.type-lightblue {
    background-color: #b3e5fc;
    border-color: #4fc3f7;
  }

  &.type-purple {
    background-color: #e1bee7;
    border-color: #ba68c8;
  }

  &.type-grey {
    background-color: #eeeeee;
    color: #666;
    border-color: #ddd;
  }

  &.readonly-cell {
    cursor: default;

    &:hover {
      transform: none;
      box-shadow: none;
    }
  }
}

.entry-content {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 6px;
}

.day-num {
  font-weight: bold;
  width: 18px;
}

.day-weekday {
  width: 12px;
  color: inherit;
  opacity: 0.7;
}

.day-type {
  font-size: 9px;
  background: rgba(0, 0, 0, 0.05);
  padding: 1px 3px;
  border-radius: 2px;
  font-weight: 600;
}

.empty-month-placeholder {
  height: 100%;
  background: repeating-linear-gradient(45deg,
      #ffffff,
      #ffffff 10px,
      #fcfcfc 10px,
      #fcfcfc 20px);
}

.input-field--label {
  display: block;
  font-size: 12px;
  font-weight: 600;
  color: #555;
  margin-bottom: 4px;
  margin-top: 8px;
}

.border {
  border: 1px solid #ddd;
}

.rounded {
  border-radius: 4px;
}

.legend-card {
  background-color: #fcfcfc;
  border-color: #eee;
}

.legend-title {
  font-size: 11px;
  font-weight: bold;
  color: #666;
  text-transform: uppercase;
  border-bottom: 1px solid #eee;
  padding-bottom: 4px;
}

.legend-grid {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.legend-item {
  display: flex;
  align-items: center;
  gap: 8px;
}

.legend-abbr {
  font-size: 9px;
  font-weight: bold;
  width: 24px;
  height: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 2px;

  &.type-red {
    background-color: #ffcdd2;
    color: #b71c1c;
  }

  &.type-yellow {
    background-color: #fff9c4;
  }

  &.type-green {
    background-color: #c8e6c9;
  }

  &.type-orange {
    background-color: #ffe0b2;
  }

  &.type-lightblue {
    background-color: #b3e5fc;
  }

  &.type-purple {
    background-color: #e1bee7;
  }

  &.type-grey {
    background-color: #eeeeee;
  }
}

.legend-text {
  font-size: 10px;
  color: #444;
}

.dynamic-holiday-item {
  border-bottom: 1px solid #eee;
  display: flex;
  align-items: center;
  font-size: 11px;
}

.holiday-date {
  font-weight: bold;
}

.h-100 {
  height: 100%;
}

.italic {
  font-style: italic;
}
</style>
